





















module.exports = {
  props: ['show_alert', 'account_status', 'nylas_setting']

  data: ->
    current_user: Session.current_user

  computed:
    show_call_to_action: ->
      @account_status == 'invalid' && @$route.name != 'integrations'

    show_support_info: ->
      @account_status != 'running' && @account_status != 'invalid'

    show_resync_info: ->
      @account_status == 'invalid' && @$route.name == 'integrations'

    quota_exceeded: ->
      @nylas_setting?.quota_exceeded != null

    to_article: ->
      'https://intercom.help/reevoutbound-marketing/pt-BR/articles/3216507-recebi-um-alerta-de-limite-de-envio-de-e-mails-excedido-e-agora'

  methods:
    redirect: ->
      @$router.push name: 'integrations'
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/account_status_info.vue